import React from 'react'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom'
import { LOGOKabSigi } from 'src/assets/image';
import { setFormSearchDatas } from 'src/config/redux/action/dataAction';

function Kategori({ dataDataset }) {
    const dispatch = useDispatch();
    return (
        <div>
            <div className="widget widget-text">
                <h3 className="widget-title">Organisasi</h3>
                <div className="ttm-author-widget">
                    <div className="author-widget_img">
                        <center>
                            <img className="author-img img-fluid" src={`${dataDataset.Agency.FileLogo}`} onError={(e) => { e.target.onerror = null; e.target.src = LOGOKabSigi }} alt={dataDataset.Agency.Name} style={{ height: 150 }} />
                        </center>
                    </div>
                    <h6>{dataDataset.Agency.Name}</h6>
                    <p className="author-widget_text">
                        {dataDataset.Agency.Description}
                    </p>
                </div>
            </div>

            <aside className="widget widget-search">
                <form role="search" method="get" className="search-form  box-shadow" action="#">
                    <div className="form-group">
                        <input
                            name="search"
                            type="text"
                            className="form-control bg-white"
                            placeholder="Cari Data..."
                            onChange={(e) => dispatch(setFormSearchDatas('SearchText', e.target.value))}
                        />
                        <Link to={'/data'}>
                            <i className="ti-search" />
                        </Link>
                    </div>
                </form>
            </aside>

            <div className="widget widget_media_image">
                <div className="banner-img-box ttm-textcolor-white text-left">
                    <div className="featured-content featured-content-banner">
                        <i className="flaticon flaticon-call" />
                        <div className="featured-title ttm-box-title">
                            <h5>Butuh Bantuan?</h5>
                        </div>
                        <div className="featured-desc">
                            <p>Jika anda butuh bantuan<br /> silahkan kontak kami.</p>
                        </div>
                        <ul>
                            <li><i className="fa fa-phone" />0714-321-021</li>
                            <li><i className="far fa-envelope" /><a href="mailto:info@satudata.sigikab.go.id">info@satudata.sigikab.go.id</a></li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Kategori
